import React from "react";
import { View, ScrollView } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { ScreenBGGradientView } from "../../common/CommonView";
import Header from "../../screens/Auth/WebScreens/Common/Header";
import Skeletons from "./Skeletons";
import LiveNowSliderSkeleton from "../home-common-components/LiveNowSliderSkeleton";
import HomeCardSkeleton from "./HomeCardSkeleton";

const HomeWebScreenSkeleton = () => {
  const deviceSize = useDeviceSize();
  const isSmallDevice =
    deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;

  return (
    <View style={{ flex: 1 }}>
      <ScreenBGGradientView />

      {/* Header - can still show since it doesn't depend on user data loading */}
      <View style={{ opacity: 0.5 }}>
        <Header
          btnSearchTapped={() => {}}
          btnWalletTapped={() => {}}
          btnStartTutorialTapped={() => {}}
          btnMessageTapped={() => {}}
          btnNotificationTapped={() => {}}
          btnProfileTapped={() => {}}
          displayTutorialButton={false}
        />
      </View>

      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={{
          paddingHorizontal: isSmallDevice ? 0 : 20,
        }}
      >
        {/* Home Header Skeleton */}
        <View
          style={{
            paddingHorizontal: isSmallDevice ? "3.5%" : 0,
            marginTop: 20,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Skeletons
              width={isSmallDevice ? "150px" : "200px"}
              height={isSmallDevice ? 24 : 32}
            />
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Skeletons
                width={isSmallDevice ? "80px" : "120px"}
                height={isSmallDevice ? 36 : 44}
                style={{ borderRadius: 8 }}
              />
              <Skeletons
                width={isSmallDevice ? "80px" : "120px"}
                height={isSmallDevice ? 36 : 44}
                style={{ borderRadius: 8 }}
              />
            </View>
          </View>
        </View>

        {/* Separator */}
        <View
          style={{
            paddingHorizontal: isSmallDevice ? "3.5%" : 0,
            marginVertical: 20,
          }}
        >
          <Skeletons height={1} width="100%" />
        </View>

        {/* Live Now Section Skeleton */}
        <LiveNowSliderSkeleton />

        {/* Browse Games Section Skeleton */}
        <View
          style={{
            paddingHorizontal: isSmallDevice ? "3.5%" : 0,
            marginTop: 30,
          }}
        >
          <Skeletons
            width={isSmallDevice ? "150px" : "180px"}
            height={isSmallDevice ? 20 : 24}
            style={{ marginBottom: 15 }}
          />
          <View style={{ flexDirection: "row", gap: 15, flexWrap: "wrap" }}>
            {Array(6)
              .fill(0)
              .map((_, index) => (
                <Skeletons
                  key={index}
                  width={isSmallDevice ? "100px" : "120px"}
                  height={isSmallDevice ? 40 : 48}
                  style={{ borderRadius: 8 }}
                />
              ))}
          </View>
        </View>

        {/* Separator */}
        <View
          style={{
            paddingHorizontal: isSmallDevice ? "3.5%" : 0,
            marginVertical: 25,
          }}
        >
          <Skeletons height={1} width="100%" />
        </View>

        {/* Popular Events Section */}
        <View
          style={{
            paddingHorizontal: isSmallDevice ? "3.5%" : 0,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 15,
            }}
          >
            <Skeletons
              width={isSmallDevice ? "120px" : "150px"}
              height={isSmallDevice ? 20 : 24}
            />
            {!isSmallDevice && (
              <Skeletons width="80px" height={20} />
            )}
          </View>
        </View>
        <HomeCardSkeleton />

        {/* Upcoming Events Section */}
        <View
          style={{
            paddingHorizontal: isSmallDevice ? "3.5%" : 0,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 15,
            }}
          >
            <Skeletons
              width={isSmallDevice ? "120px" : "150px"}
              height={isSmallDevice ? 20 : 24}
            />
            {!isSmallDevice && (
              <Skeletons width="80px" height={20} />
            )}
          </View>
        </View>
        <HomeCardSkeleton />

        {/* Recommended Events Section */}
        <View
          style={{
            paddingHorizontal: isSmallDevice ? "3.5%" : 0,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 15,
            }}
          >
            <Skeletons
              width={isSmallDevice ? "120px" : "150px"}
              height={isSmallDevice ? 20 : 24}
            />
            {!isSmallDevice && (
              <Skeletons width="80px" height={20} />
            )}
          </View>
        </View>
        <HomeCardSkeleton />

        {/* Bottom spacing */}
        <View style={{ height: 40 }} />
      </ScrollView>
    </View>
  );
};

export default HomeWebScreenSkeleton;
